export const experienceData = [
    {
        id: 1,
        company: 'SQUAD',
        jobtitle: 'DevOPS - Dev',
        startYear: '2023',
        endYear: 'Still working'
    },
    {
        id: 2,
        company: 'ALTEN',
        jobtitle: 'FullStack and Cloud Developer for French Internet Provider',
        startYear: '2021',
        endYear: '2023'
    },
    {
        id: 3,
        company: 'Monaco Telecom',
        jobtitle: 'Internship as Back End Developer',
        startYear: '2020',
        endYear: '2020 (6 months)'
    },
]